import { gql } from '@apollo/client';
import { queryFactory } from '../../../utils/gqlFactories';

const meQuery = gql`
    query {
        me {
            id
            permission {
                id
                name
            }
        }
    }
`;

interface MeData {
    id: number;
    permission: {
        id: number;
        name: string;
    };
}

const useMeQuery = queryFactory<MeData>(meQuery, 'me');

export default useMeQuery;
